import { FlightSegment } from './flight-segment.model';

export class FlightRouting {
  inbound?: FlightSegment;
  outbound!: FlightSegment;
}
